const cache = new Map<string, Intl.DisplayNames | null>();

/** Localised country name for an ISO 3166-1 alpha-2 code, falling back to `fallback`. */
export function regionName(locale: string, iso: string | null | undefined, fallback: string): string {
    if (!iso) {
        return fallback;
    }

    if (!cache.has(locale)) {
        try {
            cache.set(locale, new Intl.DisplayNames([locale, 'en'], { type: 'region' }));
        } catch {
            cache.set(locale, null);
        }
    }

    try {
        return cache.get(locale)?.of(iso.toUpperCase()) ?? fallback;
    } catch {
        return fallback;
    }
}
